import { useAuth } from '@pesto/features/src/providers/AuthProvider/AuthProvider';

import { useCurrentUserQuery, UserRole } from '../__generated__/graphql/api';
import { IS_PROD } from '../constants/global-env';
import { useRoleMimickingStore } from '../stores/useRoleMimickingStore';
import { useIsPublicRoute } from './useIsPublicRoute';

export const useCurrentRole = () => {
  const { isAuthenticated } = useAuth();
  const isPublicRoute = useIsPublicRoute();
  const { data, loading } = useCurrentUserQuery({ skip: isPublicRoute || !isAuthenticated() });
  const { currentRole: mimickedRole, isMimicking } = useRoleMimickingStore();

  const backendRole = data?.currentUser?.role ?? null;

  if (!IS_PROD && isMimicking) {
    return { role: mimickedRole, isLoading: false };
  }

  if (loading || !backendRole) {
    return { role: UserRole.SuperAdmin, isLoading: true };
  }

  return { role: backendRole, isLoading: false };
};
